import { apiAxios } from './Axios'

export const requestGet = (params) => apiAxios.get('requestGet', { params: { ...params } })
  .then(res => res)

export const requestReply = ({ key, payload }) =>
  apiAxios.post(
    'requestReply',
    { key, payload },
    { headers: { 'Content-Type': 'application/json' } }
  ).then((res) => res)

export const requestRead = (params) => apiAxios.get('requestRead', { params: { ...params } })
  .then(res => res)
